var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"loni-cell-item",class:{
        spacing: _vm.options.spacing,
        'spacing-fill': !!_vm.options.spacingFill,
        'not-line': !_vm.options.splitLine,
        arrow: _vm.next||_vm.options.nextIcon
    },style:({
        background: _vm.options.background,
        borderBottomColor: _vm.spacingFillColor
    }),on:{"click":_vm.active}},[(_vm.icon||_vm.title||_vm.$slots.prefix)?_c('div',{staticClass:"wrapper"},[(_vm.$slots.prefix)?_vm._t("prefix"):(_vm.icon)?_c('i',{staticClass:"icon loni",class:_vm.icon,style:({color:_vm.options.iconColor})}):_vm._e(),(_vm.title)?_c('span',{staticClass:"title",class:{fixed:_vm.options.titleFixed!=='auto'},style:({
                  color: _vm.options.color,
                  width: _vm.options.titleFixed
              })},[_vm._v(_vm._s(_vm.title))]):_vm._e()],2):_vm._e(),_vm._t("custom"),(_vm.$slots.default)?_c('p',{staticClass:"text",class:{
           flex: _vm.options.textFlex,
           left: _vm.options.textLeft
       },style:({color:_vm.options.textColor})},[_vm._t("default")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }